import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import getRewardPlatform from "@/service/getRewardPlatform";
import {labelizeNamedData, labelizeNamedRow} from '@/shared/helpers'
import {Form, Field} from "react-final-form";
import renderSelectField from '@/shared/components/form/Select';
import { ToggleButtonField } from '@/shared/components/form/ToggleButton';
import Select from 'react-select';
import NeoCurrencyCampaignManager from './NeoCurrencyCampaignManager';


const EditConfigurationPage = () => {
    const { id } = useParams();
    const history = useHistory();
    const [errors, setErrors] = useState({});
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        platform_name: '',
        platform_key: '',
        platform_url: '',
        platform_mode: '',
        account_identifier: '',
        account_number: '',
        customer_number: '',
        udid: '',
        etid: '',
        status: '',
        is_test: '',
        reward_platform_id: '',
        toa_merchant_min_value: '',
        toa_merchant_max_value: '',
    });
    const [rewardPlatforms, setRewardPlatforms] = React.useState([])

    useEffect(() => {
        if (rewardPlatforms.length === 0) {
            getRewardPlatform()
              .then(result => {
                  setRewardPlatforms(labelizeNamedData(result))
              })
        }
    },)

    useEffect(() => {
        const fetchConfiguration = async () => {
            try {
                const response = await axios.get(`/tango-settings/${id}`);
                const data = response.data;
                setFormData({
                    ...data,
                    status: parseInt(data.status),
                    is_test: parseInt(data.is_test)
                });
                if (data.reward_platform_id && rewardPlatforms.length > 0) {
                    const platform = rewardPlatforms.find(p => p.value === data.reward_platform_id);
                    if (platform) setSelectedPlatform(platform);
                }
            } catch (error) {
                console.error('Failed to fetch configuration:', error);
                alert('Failed to load the data.');
            }
        };

        fetchConfiguration();
    }, [id, rewardPlatforms]);

    const validateForm = (platformValue) => {
        let valid = true;
        let newErrors = {};

        const isNeo = platformValue?.label?.toLowerCase().includes('neo') ||
            formData.platform_name?.toLowerCase().includes('neo');
        console.log('isNeo:', isNeo, 'platformValue:', platformValue, 'platform_name:', formData.platform_name);
        const requiredFields = isNeo
            ? ['name', 'platform_name', 'platform_mode', 'account_identifier']
            : ['name', 'platform_name', 'platform_url', 'platform_mode', 'account_identifier', 'customer_number', 'udid', 'etid'];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                valid = false;
                newErrors[field] = 'This field is required';
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const handleChange = (e) => {
        const { name, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : e.target.value
        }));
    };


    const onSubmit = async (values) => {
        if (!validateForm(values?.reward_platform_id)) {
            alert('Please fill all required fields.');
            return;
        }

        formData.reward_platform_id = values?.reward_platform_id.value;
        try {
            await axios.put(`/tango-settings/edit/${id}`, formData);
            history.push(`/reward-platform-settings/view/${id}`);
        } catch (error) {
            console.error('Failed to update configuration:', error);
            alert('Error updating configuration');
        }
    };

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h2>Edit Reward Platform Configuration</h2>
                    <Card>
                        <CardBody>
                            <Form
                              onSubmit={onSubmit}
                              initialValues={formData}
                            >
                                {({ handleSubmit, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Field name="reward_platform_id">
                                            {({ input, meta }) => (
                                              <div className="form__form-group">
                                                  <span className="form__form-group-label">Reward Platform</span>
                                                  <div className="form__form-group-field">
                                                      <div className="form__form-group-row">
                                                          <Field
                                                            name="reward_platform_id"
                                                            component={renderSelectField}
                                                            options={rewardPlatforms}
                                                            onChange={(val) => setSelectedPlatform(val)}
                                                          />
                                                          {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                      </div>
                                                  </div>
                                              </div>
                                            )}
                                        </Field>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="name">Name:</Label>
                                            <Input type="text" name="name" id="name" value={formData.name ?? ''} onChange={handleChange} invalid={!!errors.name} />
                                            <FormFeedback>{errors.name}</FormFeedback>
                                        </FormGroup>
                                    </Col>
                                    {['platform_name', 'platform_url', 'platform_mode', 'account_identifier', 'account_number', 'customer_number', 'udid', 'etid', 'toa_merchant_min_value', 'toa_merchant_max_value'].map(field => (
                                        <Col md={6} key={field}>
                                            <FormGroup>
                                                <Label for={field}>{({ customer_number: 'Customer Number / Client Id', account_identifier: 'Account Identifier / Brand Id' })[field] || (field.replace(/_/g, ' ').charAt(0).toUpperCase() + field.replace(/_/g, ' ').slice(1))}:</Label>
                                                <Input type="text" name={field} id={field} value={formData[field] ?? ''} onChange={handleChange} invalid={!!errors[field]} />
                                                <FormFeedback>{errors[field]}</FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    ))}
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Configuration</Label>
                                    <Select
                                        options={[{ value: 0, label: 'Production' }, { value: 1, label: 'Test' }]}
                                        value={formData.is_test === 1 ? { value: 1, label: 'Test' } : { value: 0, label: 'Production' }}
                                        onChange={opt => setFormData(prev => ({ ...prev, is_test: opt.value }))}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        styles={{ menuList: base => ({ ...base, top: 0 }) }}
                                    />
                                </FormGroup>
                                        <div className="d-flex align-items-center mb-3">
                                            <span className="mr-2" style={{ minWidth: 130 }}>Active</span>
                                            <div style={{ width: 60 }}>
                                                <ToggleButtonField
                                                    name="status"
                                                    value={formData.status === 1}
                                                    onChange={val => setFormData(prev => ({ ...prev, status: val ? 1 : 0 }))}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Button type="submit" color="primary">Save Changes</Button>
                                <Button type="button" color="secondary" onClick={() => history.goBack()}>Cancel</Button>
                            </form>
                                )}
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {formData.reward_platform_id && (selectedPlatform?.label?.toLowerCase().includes('neo') || formData.platform_name?.toLowerCase().includes('neo')) && (
                <Row>
                    <Col md={12}>
                        <NeoCurrencyCampaignManager rewardPlatformId={formData.reward_platform_id} />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default EditConfigurationPage;
